import { pick, uniq } from 'lodash-es'
import eboInstance from './ebo'
import { clearCache } from './algolia'
import { isAddress } from '~/utils/validation'
import { CHAIN_ID } from '~/utils/constants'

let lastProfileUpdate = 0
export const saveProfilePrep = async (profile) => {
  try {
    const _whitelist = 'address,name,avatar,bio,intro,chainId'.split(',')
    const _data = pick(profile, _whitelist)
    if (!isAddress(_data.address)) throw new Error('Invalid Address')
    if (isNaN(_data.chainId)) throw new Error('Invalid ChainId')
    const { data } = await eboInstance({
      method: 'put',
      url: `/profiles/${profile.address}`,
      data: _data,
    })
    console.info({ savedProfile: data })
    return data
  } catch (e) {
    console.error(`Failed Saving Profile`, e)
    throw e
  }
}

export const saveProfile = async (profile) => {
  try {
    if (!isAddress(profile.address)) throw new Error('Invalid Address')
    const _data = pick(profile, ['message', 'signature', 'address'])
    const { data } = await eboInstance({
      method: 'post',
      url: `/profiles/${profile.address}`,
      data: _data,
    })
    lastProfileUpdate = Date.now()
    await clearCache()
    console.info({ savedProfile: data })
    return data
  } catch (e) {
    console.error(`Failed Saving Profile`, e)
    throw e
  }
}

export const getProfile = async (address) => {
  try {
    if (!isAddress(address)) throw new Error('Invalid Address')
    const { data } = await eboInstance({
      method: 'get',
      url: `/profiles/${address}`,
      params: {
        chainId: CHAIN_ID,
        lastProfileUpdate,
      },
    })
    console.info({ profile: data })
    return data
  } catch (e) {
    // Don't react because an account may not have a profile
    console.info(`Failed Getting Profile for ${address}`)
  }
  return null
}

export const getProfiles = async (addresses) => {
  if (!addresses.length) return []
  try {
    const validAddresses = uniq(addresses.filter((a) => isAddress(a)))
    if (!validAddresses.length) throw new Error('Addresses Invalid')
    const { data } = await eboInstance({
      method: 'get',
      url: `/profiles/`,
      // Max 45
      params: {
        addresses: validAddresses.slice(0, 45).join(','),
        chainId: CHAIN_ID,
        lastProfileUpdate,
      },
    })
    console.info({ profiles: data })
    return data
  } catch (e) {
    console.info(`Failed Getting Profiles`, e)
  }
  return []
}

export const witnessWallet = async (address) => {
  try {
    if (!isAddress(address)) {
      return console.info(`Calling witness wallet with address ${address}`)
    }
    await eboInstance({
      method: 'put',
      url: `/profiles/${address}/witness`,
      params: { chainId: CHAIN_ID },
    })
  } catch (e) {
    console.error(`Failed witness wallet with address ${address}`, e)
  }
}
